exports.CONTENT_PER_PAGE = 8;
exports.PAGE_PER_SCREEN = 4;

exports.POST = 'post';
exports.PORTFOLIO = 'portfolio';
exports.RESUME = 'resume';

exports.SITE_URL = 'https://satzcalvin.netlify.com/';
